// Die Kacheln der Produktgalerie liegen waagerecht nebeneinander. Alles ausser
// der ersten steht damit ausserhalb des sichtbaren Ausschnitts und bleibt mit
// loading="lazy" weiss, bis man daneben steht. Gemessen am 11.09.2026 auf dem
// Live-Theme und auf agent-growth, Weissburgunder 2025: Bild 2 und 3 waren auch
// nach dem Scrollen leer.
//
// theme.js versucht das in ScrollCarousel (preloadImages), haengt dafuer aber an
// einem IntersectionObserver und gibt nur die Nachbarkachel frei -- die dritte
// Kachel bleibt weiss, bis man auf der zweiten steht. Hier bewusst ohne
// Beobachter: eine Galerie hat eine Handvoll Medien, und das fruehere
// Rasterlayout auf dem Rechner hat ohnehin alle geladen.
if (!window.dreissigackerGalerieVorladen) {
  window.dreissigackerGalerieVorladen = true;

  // Nur Bilder. Videos bleiben unangetastet: preload="none" gehoert zur
  // Lazy-Mechanik von video-media, und ein Umstellen auf "metadata" nimmt dem
  // Custom Element die Grundlage, auf der es seine Quellen nachlaedt.
  const freigeben = () => {
    document.querySelectorAll('.product-gallery__media img[loading="lazy"]').forEach((bild) => {
      bild.removeAttribute('loading');
    });
  };

  freigeben();
  // product-rerender tauscht die Galerie bei Varianten- und Mengenwechsel aus.
  // Ein Dauerbeobachter ueber das ganze Dokument war dafuer zu grob: er lief bei
  // jeder fremden DOM-Aenderung mit. Diese Anlaesse decken jeden Neuaufbau ab,
  // den das Theme selbst ausloest.
  addEventListener('load', freigeben);
  addEventListener('pageshow', freigeben);
  document.addEventListener('variant:change', freigeben);
  document.addEventListener('shopify:section:load', freigeben);
}
